import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabela-de-classificacao-de-severidade-da-seca',
  templateUrl: './tabela-de-classificacao-de-severidade-da-seca.component.html',
  styleUrls: ['./tabela-de-classificacao-de-severidade-da-seca.component.css']
})
export class TabelaDeClassificacaoDeSeveridadeDaSecaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
